//imports
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

//Action types
import {
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST,
    ACCOUNTS_EDIT_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_ACCOUNT_REQUEST,
    ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST,
    ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST
} from 'Redux/actionTypes';

//Actions
import {
    accountsSearchRolesResult,
    accountsGetAccountResult,
    accountsGetRoleResult,
    accountsCreateAccountResult,
    accountsGetCustomRoleResult,
    accountsEditAccountResult,
    accountsGetRoleModuleTemplateResult,
    accountsSearchTimeZonesResult,
    accountsCredencialValidationResult,
} from 'Redux/actions';

function* credencialValidation({ payload }) {
    try {
        let QUERY = `
        query getWexLogin ($username: String!, $password: String!) {
            result: getWexLogin (username: $username, password: $password)
        }`

        let data = yield call(
            clientQuery,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL
        );

        if (data.result) {
            yield put(accountsCredencialValidationResult({ success: true }))
        } else {
            yield put(accountsCredencialValidationResult({ error: true }))
        }

    } catch (exc) {
        yield put(accountsCredencialValidationResult({ error: true }))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'searchRoles');
    }
}
function* searchRoles({ payload }) {
    try {
        let QUERY = `
        query searchRoles ($conditions: [RoleSearchInput], $sort: [RoleSortInput], $limit: Int, $offset: Int) {
            result: searchRoles (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["dealerId"],
                        terms: [payload],
                        exact: true
                    },
                    {
                        fields: ["isCustom"],
                        terms: [false],
                        exact: true
                    }
                ],
                limit: 1000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result;
            yield put(accountsSearchRolesResult(items))
        } else {
            yield put(accountsSearchRolesResult([]))
        }

    } catch (exc) {
        yield put(accountsSearchRolesResult([]))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'searchRoles');
    }
}

function* getRole({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                            parentModuleName
                        }
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["roleId"],
                    terms: [payload],
                    exact: true
                },
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result;
            yield put(accountsGetRoleResult(items))
        } else yield put(accountsGetRoleResult([]))

    } catch (exc) {
        yield put(accountsGetRoleResult([]))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'getRole');
    }
}

function* getAccount({ payload }) {
    try {
        let QUERY = `
            query getCompany ($id: Int!) {
                result: getCompany (id: $id) {
                    id
                    name
                    status
                    language
                    timezone
                    timezoneId
                    roleId
                    dealerId
                    dealer {
                        id
                        name
                    }
                    role {
                        id
                        name
                        description
                        isCustom
                        roleModules {
                            id
                            roleId
                            moduleId
                            module {
                                id
                                projectId
                                code
                                userCode
                                name
                                groupName
                                parentModuleId
                                category
                                modulesCount
                                parentModuleName
                            }
                            c
                            u
                            d
                            isDefault
                        }
                    }
                    compdata {
                        promiles
                        promilesLogin
                        promilesEmail
                        fuelCardCompanyCode
                    }
                    integrations {
                        integrationId
                        status
                        parameters
                    }
                    customRoleId
                    username
                    email
                    internal
                    crmId
                    sendWelcomeEmail
                    tacRequired
                    rgeoEngine
                    speedLimitEngine
                    tags
                    readonly
                    tagMode
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                id: payload
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(accountsGetAccountResult(data?.result))
        }

    } catch (exc) {
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'getRole');
    }
}

function* createAccount({ payload }) {
    try {
        let QUERY = `
            mutation createCompany ($dealerId: Int!, $name: String!, $language: Int, $username: String!, $email: String, $internal: Boolean, $crmId: String, $roleId: Int!, $moduleIds: [Int], $compdata: CompdataInput, $timezoneId: Int, $sendWelcomeEmail: Boolean, $tacRequired: Boolean, $rgeoEngine: enumMapProvider, $speedLimitEngine: enumMapProvider, $integrations: [CompanyIntegrationInput], $tagIds: [Int], $readonly: Boolean, $tagMode: enumTagMode) {
                result: createCompany (dealerId: $dealerId, name: $name, language: $language, username: $username, email: $email, internal: $internal, crmId: $crmId, roleId: $roleId, moduleIds: $moduleIds, compdata: $compdata, timezoneId: $timezoneId, sendWelcomeEmail: $sendWelcomeEmail, tacRequired: $tacRequired, rgeoEngine: $rgeoEngine, speedLimitEngine: $speedLimitEngine, integrations: $integrations, tagIds: $tagIds, readonly: $readonly, tagMode: $tagMode) {
                    id
                    name
                    compdata {
                        promiles
                        promilesLogin
                        promilesEmail
                        fuelCardCompanyCode
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(accountsCreateAccountResult(data?.result))
        } else {
            yield put(accountsCreateAccountResult({ error: true }))
        }

    } catch (exc) {
        yield put(accountsCreateAccountResult({ error: true }))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'createAccount', true);
    }
}

function* getCustomRol({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                            parentModuleName
                        }
                        c
                        u
                        d
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["roleId"],
                        terms: [payload],
                        exact: true
                    }
                ],
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data.result
            yield put(accountsGetCustomRoleResult(items))
        } else yield put(accountsGetCustomRoleResult([]))

    } catch (exc) {
        yield put(accountsGetCustomRoleResult([]))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'getCustomRol');
    }
}

function* editAccount({ payload }) {
    try {
        let QUERY = `
            mutation updateCompany ($id: Int!, $name: String, $language: Int, $internal: Boolean, $crmId: String, $roleId: Int, $moduleIds: [Int], $dealerId: Int, $compdata: CompdataInput, $timezoneId: Int, $sendWelcomeEmail: Boolean, $tacRequired: Boolean, $rgeoEngine: enumMapProvider, $speedLimitEngine: enumMapProvider, $integrations: [CompanyIntegrationInput], $tagIds: [Int], $readonly: Boolean, $tagMode: enumTagMode) {
                result: updateCompany (id: $id, name: $name, language: $language, internal: $internal, crmId: $crmId, roleId: $roleId, moduleIds: $moduleIds, dealerId: $dealerId, compdata: $compdata, timezoneId: $timezoneId, sendWelcomeEmail: $sendWelcomeEmail, tacRequired: $tacRequired, rgeoEngine: $rgeoEngine, speedLimitEngine: $speedLimitEngine, integrations: $integrations, tagIds: $tagIds, readonly: $readonly, tagMode: $tagMode) {
                    id
                    name
                    compdata {
                        promiles
                        promilesLogin
                        promilesEmail
                        fuelCardCompanyCode
                    }
                    integrations {
                        integrationId
                        parameters
                        status
                    }
                }
            }
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            payload,
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(accountsEditAccountResult(data?.result))
        }

    } catch (exc) {
        yield put(accountsEditAccountResult({ error: true }))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'editAccount', true);
    }
}

function* searchTemplateRoleModules({ payload }) {
    try {
        let QUERY = `
            query searchRoleModules ($conditions: [RoleModuleSearchInput], $sort: [RoleModuleSortInput], $limit: Int, $offset: Int) {
                result: searchRoleModules (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        roleId
                        moduleId
                        module {
                            id
                            projectId
                            code
                            userCode
                            name
                            groupName
                            parentModuleId
                            category
                            modulesCount
                            parentModuleName
                        }
                        c
                        u
                        d
                        isDefault
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [
                    {
                        fields: ["roleId"],
                        terms: [payload],
                        exact: true
                    }
                ],
                sort: {
                    field: "module_name",
                    order: "ASC"
                },
                limit: 2000,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result
            yield put(accountsGetRoleModuleTemplateResult(items))
        } else yield put(accountsGetRoleModuleTemplateResult([]))

    } catch (exc) {
        yield put(accountsGetRoleModuleTemplateResult([]));
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'searchTemplateRoleModules');
    }
}

function* searchTimezones() {
    try {
        let QUERY = `
            query searchTimezones ($conditions: [TimezoneSearchInput], $sort: [TimezoneSortInput], $limit: Int, $offset: Int) {
                result: searchTimezones (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                    items {
                        id
                        name
                    }
                    total
                }
            }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: [],
                limit: 600,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            const { items } = data?.result
            yield put(accountsSearchTimeZonesResult(items))
        }

    } catch (exc) {
        yield put(accountsSearchTimeZonesResult([]))
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'searchTimezones');
    }
}

export const getSfAccount = async (input = '') => {
    try {
        let QUERY = `
        query searchSfAccount ($name: String, $limit: Int, $offset: Int) {
            result: searchSfAccount (name: $name, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                }
            }
        }`
        return await clientQuery(QUERY, {
            name: input,
            limit: 15,
            offset: 0
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/accounts/views/components/createEditAccount/redux/saga', 'getSfAccount');
    }
}

function* watchCatalogRequests() {
    yield takeEvery(ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_ROLES_REQUEST, searchRoles);
    yield takeEvery(ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_REQUEST, getRole);
    yield takeEvery(ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ACCOUNT_REQUEST, getAccount);
    yield takeEvery(ACCOUNTS_CREATE_ACCOUNT_REQUEST, createAccount);
    yield takeEvery(ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_CUSTOM_ROLE_REQUEST, getCustomRol);
    yield takeEvery(ACCOUNTS_EDIT_ACCOUNT_REQUEST, editAccount);
    yield takeEvery(ACCOUNTS_CREATE_EDIT_ACCOUNT_GET_ROLE_MODULES_TEMPLATE_REQUEST, searchTemplateRoleModules);
    yield takeEvery(ACCOUNTS_CREATE_EDIT_ACCOUNT_SEARCH_TIMEZONES_REQUEST, searchTimezones);
    yield takeEvery(ACCOUNTS_CREDENCIAL_VALIDATION_REQUEST, credencialValidation);
}
//credencialValidation


//Saga Export
export default function* rootSaga() {
    yield all([
        fork(watchCatalogRequests)
    ]);
}